import React from 'react'
import Feature from '../Components/Feature'
import Footer from '../Components/Footer'
import Hero from '../Components/Hero'
import Navbar from '../Components/Navbar'
import News from '../Components/News'
import Record from '../Components/Record'
import Search from '../Components/Search'
import Services from '../Components/Services'


const Home = () => {
    return (
        <>
            <Navbar />
            <Hero />
            <Feature />
            <Services />
            <Record />
            <News />
            <Footer />
            <Search />

        </>
    )
}

export default Home